import React from 'react';
import {
    Subtitle,
    Title,
} from 'src/common/components/orderDetails/trackingNumberLabel/TrackingNumberLabel.styled';
import OpenInNew from 'src/assets/images/OpenInNew.svg';
import { useTranslation } from 'react-i18next';
  
const TrackingNumberLabel = (props) => {
    const handleClick = (trackingURL) => {
        trackingURL ? window.open(trackingURL) : null;
    };
    const { t } = useTranslation();
    return (
        <>
            <Title color={'#202124'} fontSize={'14px'}>
                {props.isHighlight
                    ? props.textHighlightedWords(t('orders.shipTrackLabels.trackingNoAndUrl'))
                    : t('orders.shipTrackLabels.trackingNoAndUrl')}
            </Title>
            {!props.isTrackingNumberNotAvailable && props?.trackingDetails ? (
                <>
                    {props?.trackingDetails?.map((trackValue) => {
                        return (
                            trackValue?.value !== t('procedure.unidSurgeryInfo.none') ? 
                            (<Subtitle
                                width="70%"
                                color={'#1010EB'}
                                fontSize={'16px'}
                                display={'flex'}
                                onClick={() =>
                                    handleClick(
                                        trackValue?.value
                                            ? trackValue.value
                                            : null
                                    )
                                }
                                cursor={'pointer'}
                                key={trackValue.key}
                            >
                                {trackValue?.key
                                    ? props.isHighlight
                                        ? props.textHighlightedWords(
                                              trackValue.key
                                          )
                                        : trackValue.key
                                    : null}
                                &nbsp;&nbsp;
                                <span
                                    style={{
                                        margin: '3px 0 0 0',
                                    }}
                                >
                                    <img
                                        src={OpenInNew}
                                        style={{
                                            width: '16px',
                                            height: '16px',
                                        }}
                                    />
                                </span>
                            </Subtitle>) :
                            (<Subtitle
                                color={'#202124'}
                                fontSize={'15px'}
                                lineHeight={'20px'}
                            >
                                {props.textHighlightedWords(
                                                trackValue?.key
                                            )}
                            </Subtitle>)
                        );
                    })}
                </>
            ) : (
                <>
                    <Subtitle
                        color={'#202124'}
                        fontSize={'15px'}
                        lineHeight={'20px'}
                    >
                        {t('common.noTracking')}
                    </Subtitle>
                </>
            )}
        </>
    );
};

export default TrackingNumberLabel;
